import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/observable/throw';
import { catchError } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { CookieService } from 'ngx-cookie-service';


@Injectable()
export class GlobleApiService {
    $sharedData = new Subject()
    constructor(private http: HttpClient ,private cookieService: CookieService) { }

      userDetailes():Observable <any> {
        return this.http.get<any>(`${environment.accountHost}/user_details`)
      }
      $logout(){
        return this.http.get<any>(`${environment.host}/logout`)
      }
      $tenantDetails(){
        return this.http.get<any>(`${environment.host}/tenant_details/${this.cookieService.get("_PAOID")}`)
      }

      $checkPasswordAndChangePasword(data:any):Observable <any>{
        data.org_id = this.cookieService.get('_PAOID');
        return this.http.post<any>(`${environment.accountHost}/password_reset`,data)
      }

      $getCountTest():Observable <any>{
        let org_id = this.cookieService.get('_PAOID');
        return this.http.get<any>(`${environment.userHost}/get_test_count/${org_id}`)
      }
      


}



// WEBPACK FOOTER //
// ./src/app/application/services/api-service/globle-api.service.ts